import { API_URL } from '../configAndUrls.js'
import { apiRequest, getAuthHeaders, setAuthToken } from '../http.js'

export const authApi = {
login: async (email, password) => {
      const data = await apiRequest('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      })
      if (data.token) {
        setAuthToken(data.token)
      }
      return data
    },

    logout: async () => {
      try {
        await apiRequest('/auth/logout', { method: 'POST' })
      } finally {
        setAuthToken(null)
      }
    },

    
    getMe: async () => {
      return apiRequest('/auth/me')
    },

    patchOnboardingGuides: async (body) => {
      return apiRequest('/auth/me/onboarding-guides', {
        method: 'PATCH',
        body: JSON.stringify(body),
      })
    },

    
    invite: async ({ email, role, clientId, influencerId }) => {
      return apiRequest('/auth/invite', {
        method: 'POST',
        body: JSON.stringify({ email, role, clientId, influencerId }),
      })
    },
    resendInvite: async (payload) => {
      return apiRequest('/auth/invite', {
        method: 'POST',
        body: JSON.stringify(payload),
      })
    },

    
    updateProfile: async (profileData) => {
      const data = await apiRequest('/auth/profile', {
        method: 'PUT',
        body: JSON.stringify(profileData),
      })
      return data.user
    },

    
    uploadProfilePicture: async (file) => {
      const formData = new FormData()
      formData.append('file', file)

      const response = await fetch(`${API_URL}/auth/profile/picture`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: formData,
      })

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.error || 'Upload failed')
      }

      const data = await response.json()
      return data
    },

    
    removeProfilePicture: async () => {
      await apiRequest('/auth/profile/picture', { method: 'DELETE' })
      return { message: 'Profile picture removed successfully' }
    },

    
    joinVerify: async (token) => {
      const q = token ? `?token=${encodeURIComponent(token)}` : ''
      return apiRequest(`/auth/join/verify${q}`, token ? undefined : { method: 'POST', body: JSON.stringify({ token }) })
    },

    
    joinComplete: async (token, password, profile = {}) => {
      const { firstName, lastName } = profile
      const data = await apiRequest('/auth/join/complete', {
        method: 'POST',
        body: JSON.stringify({
          token,
          password,
          ...(firstName != null && String(firstName).trim() ? { firstName: String(firstName).trim() } : {}),
          ...(lastName != null && String(lastName).trim() ? { lastName: String(lastName).trim() } : {}),
        }),
      })
      if (data.token) setAuthToken(data.token)
      return data
    },

    
    magicLinkRequest: async (email) => {
      return apiRequest('/auth/magic-link/request', {
        method: 'POST',
        body: JSON.stringify({ email }),
      })
    },

    
    magicLinkVerify: async (token) => {
      const data = await apiRequest('/auth/magic-link/verify', {
        method: 'POST',
        body: JSON.stringify({ token }),
      })
      if (data.token) setAuthToken(data.token)
      return data
    },

    completeOnboarding: async (body) => {
      const data = await apiRequest('/auth/complete-onboarding', {
        method: 'POST',
        body: JSON.stringify(body),
      })
      return data.user
    },

    
    endImpersonation: async () => {
      return apiRequest('/auth/impersonate/end', { method: 'POST' })
    },
}
